module.exports = __webpack_public_path__ + "static/media/fill-1.29f5652d.svg";